import { render } from "./demo-day-presentations-finished-banner-content.vue?vue&type=template&id=3d5dccf8"
import script from "./demo-day-presentations-finished-banner-content.vue?vue&type=script&lang=js"
export * from "./demo-day-presentations-finished-banner-content.vue?vue&type=script&lang=js"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__